import React, { useState } from 'react';

import {
  ThemedFilterList,
  ThemedFilter,
  ThemedOption,
} from '../../themes';
import { noop } from '../../utils';


const Option = ({ name, slug, image, isActive, onClick }) => {
  return (
    <ThemedOption name={ name } slug={ slug } image={ image } isActive={ isActive } onClick={ onClick } />
  );
};


const Filter = ({ name, options, activeOptions, setFilter, isCollapsed, onClick }) => {
  const optionsList = (
    options.map(option => {
      const isActive = activeOptions.includes(option.slug);
      const onClickOption = isActive ? () => setFilter(option) : noop;
      return (
        <Option key={ option.slug } name={ option.name } slug={ option.slug } image={ option.image } isActive={ isActive } onClick={ onClickOption } />
      );
    })
  );
  return (
    <ThemedFilter name={ name } options={ optionsList } onClick={ onClick } isCollapsed={ isCollapsed } />
  );
};

const Filters = ({ filters, activeFilters, setFilter }) => {
  const [openFilter, setOpenFilter] = useState(null);
  if (filters.hasFilters) {
    const filtersList = (
      filters.filters.map(filter => {
        const activeOptions = activeFilters[filter.url];
        const isCollapsed = !(filter.id === openFilter);
        const onClick = () => {
          if (openFilter !== filter.id) {
            setOpenFilter(filter.id);
          } else {
            setOpenFilter(null);
          }
        };
        return (
          <Filter
            key={ filter.id }
            name={ filter.label }
            options={ filter.options }
            activeOptions={ activeOptions }
            setFilter={ setFilter }
            isCollapsed={ isCollapsed }
            onClick={ onClick }
          />
        );
      })
    );
    return (
      <ThemedFilterList filters={ filtersList } />
    );
  }

  return <></>;
};

export default Filters;
